
export class SgfDepPlazo {
}

export class SocioDepPlazo {
    id: {
        codProducto: number;
        codCuenta: number;
    };
    stsDeposito: string;
    fecVencimiento: Date;
    fecDeposito: Date;
    numPlazo: number;
    valDeposito: number;
    valTasaInteres: number;
    valTasaImpuesto: number;
    valInteres: number;
    valImpuesto: number;

  

}